"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trekker = void 0;
const tslib_1 = require("tslib");
const types_1 = require("./types");
const es6_1 = (0, tslib_1.__importDefault)(require("fast-deep-equal/es6"));
const isDevelopment = (process.env.NODE_ENV || 'development') === 'development';
class Trekker {
    constructor(context, bus) {
        this.bus = bus;
        this.context = Object.freeze(context);
    }
    addToContext(more) {
        if (isDevelopment) {
            Object.entries(more)
                .filter(([key, value]) => this.context[key] !== value)
                .forEach(([key, newValue]) => {
                if (!Array.isArray(newValue)) {
                    if (this.context[key] !== null && this.context[key] !== undefined) {
                        if (!(0, es6_1.default)(this.context[key], newValue)) {
                            console.warn(`Trekker: overriding ${key}`, {
                                newValue, oldValue: this.context[key]
                            });
                        }
                    }
                }
            });
        }
        const mergedArrays = Object.assign({}, more);
        Object.keys(more)
            .forEach((key) => {
            var _a;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const newValue = mergedArrays[key];
            if (Array.isArray(newValue)) {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const oldValue = ((_a = this.context) === null || _a === void 0 ? void 0 : _a[key]) || [];
                mergedArrays[key] = [...oldValue, ...newValue];
            }
        });
        const fullNewContext = Object.assign(Object.assign({}, this.context), mergedArrays);
        if ((0, es6_1.default)(fullNewContext, this.context)) {
            return this;
        }
        return new Trekker(fullNewContext, this.bus);
    }
    event(name, extra) {
        if (!extra) {
            this.bus.dispatchEvent(new types_1.PrivateTrekkerEvent(name, this.context));
        }
        else {
            this.addToContext(extra).event(name);
        }
    }
    track(name, func, extra) {
        return (w) => {
            this.event(name, extra);
            return func(w);
        };
    }
}
exports.Trekker = Trekker;
//# sourceMappingURL=trekker.js.map